import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ISolicitudCompletarModel } from 'src/app/models/interfaces/solicitud/ISolicitudCompletarModel';
import { SolicitudContratistaModel } from 'src/app/models/solicitud/SolicitudContratistaModel';
import { SolicitudResultadoBusqueda } from 'src/app/models/solicitud/solicitudResultadoBusqueda';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SolicitudContratistaService {
  // private configUrl = 'api/solicitudes';
  private configUrl = [environment.apiGatewayUrl, 'solicitudes'].join('/');
  
  constructor(private http: HttpClient) { }

  // getListDocumentacion() : Observable<DocumentacionRequeridaModel[]> {
  //   return this.http.get<DocumentacionRequeridaModel[]>(this.configDocumentacionUrl);
  // }

  // getList() : Observable<SearchResultModel<SolicitudResultadoBusqueda[]>> {
  //   return this.http.get<SearchResultModel<SolicitudResultadoBusqueda[]>>(this.configUrl);
  // }

  // getById(id: number) : Observable<SolicitudContratistaModel> {
  //   return this.http.get<SolicitudContratistaModel>(`${this.configUrl}/${id}`);
  // }

  guardar(model: ISolicitudCompletarModel){
    return this.http.post<ISolicitudCompletarModel>(`${this.configUrl}/${model.idSolicitud}/ingresos`, model);
  }
}
